import React from 'react'
import { Loader, Input, Select } from './common'
import model from './model'
import Table from './table'

const none = __('buttons_notsubscribe').toLowerCase();

export const Actions = {
	LOADING: 'LOADING',
	SAVE: 'SAVE',
}

export const saveSubscription = (courses, fields, options, callback = null) => {
	const _courses = courses.reduce(
		(_course, course) => {
			if (course.actions.length > 0 || course.is_interested == 1) {
				_course[course.course_code] = {
					courseaction_id: course.courseaction_id || null,
					is_interested: course.is_interested == 1 ? 1 : 0,
					ord: course.ord
				};
			}
			return _course;
		},
		{}
	)
	const cfields = Object.keys(fields).reduce((fields, name) => {
		if (fields[name].value) {
			fields[name] = fields[name].value;
		}
		return fields;
	}, {})
	const data = {
		tp_code: options.trainingpath_code,
		courses: _courses,
		fields: cfields
	}
	if (callback) {
		if (options.entity_code) {
			data.entity_code = options.entity_code
		}
		http.post('/trainingpaths/saveSubscription.json',
			{ data: data },
			(response, success) => {
				callback(response, success);
			}
		)
		return
	}
	return dispatch => {
		dispatch({ type: Actions.LOADING });
		http.post('/trainingpaths/saveSubscription.json',
			{ data: data },
			(response, success) => {
				dispatch({ type: Actions.LOADING, loading: false, status: response.status });
			}
		)
	}
}

export class SubscribeComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {has_validated: false};
		this.onRequestSave = this.onRequestSave.bind(this)
	}

	checkAction(course, action, e) {
		if (action != null) {
			course.courseaction_id = e.currentTarget.checked ? action.courseaction_id : null;
		}
		else {
			course.is_interested = e.currentTarget.checked;
		}
		if (this.state.has_validated) {
			this.validate();
		}
		else {
			this.forceUpdate();
		}
	}

	// validar se user selecionou ações de cursos obrigatórios
	validate(validate_fields = false) {
		const { courses, fields } = this.props
		let has_errors = false;

		if (validate_fields) {
			Object.keys(fields).forEach(name => {
				const field = fields[name];
				if (field.required && !field.value) {
					mbox.info('Tem de preencher: ' + field.label, 'Inscrição');
					return false;
				}
			})
		}
		//return false;
		this.state.has_validated = true;
		courses.data.forEach(course => {
			course._error =
				course.required == 1 && course.actions.length > 0 && !course.courseaction_id
					? __('matriculations_required_action')
					: ( course.required == 1 && course.actions.length == 0 && !course.is_interested
						? __('matriculations_required_interest')
						: null
					);
			has_errors = has_errors || (course._error ? true : false);
		});
		this.forceUpdate();
		if (has_errors) {
			hp.ui.dialog.inline({war: __('attrs_mandatory_string')});
		}
		return !has_errors;
	}

	onRequestSave() {
		const { courses, fields, trainingpath, entity_code, afterSave } = this.props
		if (this.validate(true)) {
			this.props.saveSubscription(courses.data, fields, {
				trainingpath_code: trainingpath.trainingpath_code,
				entity_code: entity_code || null
			}, afterSave || null);
		}
	}

	onFieldChange(component, e) {
		//if (component)
		debugger;
	}

	render() {
		const disabled = this.props.courses.status != 0;
		const { trainingpath, onCancel, label_interested } = this.props;
		const courses = this.props.courses.data.map((course, i) => {
			let actions = null;

			// se não existirem ações para o curso, permite marcar como curso de interesse
			if (course.actions.length == 0) {
				actions = [
					<div key='chk' className="checkbox">
						<label>
							<input type="checkbox" name={course.course_code} onChange={this.checkAction.bind(this, course, null)} disabled={disabled || course.is_interested == 2} checked={course.is_interested >= 1} />
							{label_interested || __('courseactions_interested')}
						</label>
					</div>
				]
				actions.push(
					<div key='ord'>
						<label className={disabled || course.is_interested != 1 ? 'disabled' : null}>{__('attrs_ord_pref')}</label>
						<Input type="number" model={course} name='ord' classNameEl='hp-input-max-60' disabled={disabled || course.is_interested != 1} value={course.ord} />
					</div>
				)
			}
			else if (course.actions.length == 1) {
				actions =
					<div className="checkbox" title={course.actions[0].courseaction_id}>
						<label>
							<input type="checkbox" name={course.course_code} onChange={this.checkAction.bind(this, course, course.actions[0])} disabled={disabled || course.confirmed > 0} checked={course.courseaction_id == course.actions[0].courseaction_id} />
							{course.actions[0].evt_start} - {course.actions[0].evt_end}
							{course.actions[0].obs ? <span className="legend-label" title={course.actions[0].obs_title}> ({course.actions[0].obs})</span> : null}
						</label>
					</div>;
			}
			else {
				actions = course.actions.map((action, i) =>
					<div className="radio" key={i}  title={action.courseaction_id}>
						<label>
							<input type="radio" name={course.course_code} onChange={this.checkAction.bind(this, course, action)} disabled={disabled || course.confirmed > 0} checked={course.courseaction_id == action.courseaction_id} />
							{action.evt_start ? `${action.evt_start} - ${action.evt_end}` : ''}
							{action.obs ? <span className="legend-label" title={action.obs_title}> ({action.obs})</span> : null}
						</label>
					</div>
				);
			}
			return (
				<tr key={i} className={course._error ? 'error' : null}>
					<td>{!this.state.has_validated
						? null
						: (course._error
							? <em className="la la-exclamation-circle" title={course._error} />
							: <em className="la la-check" />
						)}
					</td>
					<td>{course.course_code}</td>
					<td>{course.course} {course.required == 1 ? '*' : null}</td>
					<td>{actions}</td>
				</tr>
			)
		});
		const fields = Object.keys(this.props.fields).map(name => {
			const field = this.props.fields[name];
			const component = field.data
				? <Select
					model={field} name='value'
					options={field.data}
					disabled={field.readonly || disabled}
					//onChange={this.onFieldChange.bind(this.component)}
				  />
				: <Input model={field} name='value' disabled={field.readonly || disabled} />
			return (
				<div key={name} className="form-group row">
					<label htmlFor={field.label} className="col-xs-2">
						{field.label}
						<span>{field.required ? '*' : ''}</span>
					</label>
					<div className="col-xs-10 col-md-6">
						{component}
					</div>
				</div>
			);
		});
		let _actions;
		if (onCancel) {
			_actions = [
				<button key='c' className="btn btn-default" onClick={onCancel}>
					<em className="la la-undo" />
					<span>{__('buttons_cancel')}</span>
				</button>,
				<button key='i' className="btn btn-primary" onClick={this.onRequestSave} disabled={disabled}>
					<em className="la la-check" />
					<span>{hp.settings.requires_validation ? __('courseactions_pre_subscribe') : __('courseactions_subscribe')}</span>
				</button>
			]
		}
		else {
			_actions = [
				<button key='c' className="btn btn-default" onClick={window.history.back}>
					<em className="la la-undo" />
					<span>{__('buttons_back')}</span>
				</button>,
				<button key='i' className="btn btn-primary" onClick={this.onRequestSave} disabled={disabled}>
					<em className="la la-check" />
					<span>{hp.settings.requires_validation ? __('courseactions_pre_subscribe') : __('courseactions_subscribe_me')}</span>
				</button>
			]
		}
		return (
			<div>
				{this.props.courses.status == 1
					? <div className="alert alert-info center">{__('matriculations_is_validating')}</div>
					: (this.props.courses.status == 2
					? <div className="alert alert-success center">{__('matriculations_is_validated')}</div>
						: null
					)
				}
				<div className="form-check-label">
					<em className="la la-info-circle" />
					<span className="legend-label"> {__('matriculations_pf_obs')}</span>
				</div>
				<div className="widget-box">
					<div className="widget-title">
						{this.props.courses.loading ? <Loader className="inline" dimmed={false} /> : null}
						<h4>
							<span>Percurso formativo: {trainingpath.description}</span>
							<div className="btn-group btn-group-xs pull-right">
								{_actions}
							</div>
						</h4>
					</div>
					<div className="widget-content">
						<div className="padding-top-16 padding-left-16">
							{fields}
						</div>
						<table className="table alternate">
							<tbody>
								{courses}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		);
	}
}

export const getRowPropsExpanded = () => ({className: 'class_slide'});

class UserTPCourses extends React.Component {
	onAfterSave = (response, success) => {
		const { row } = this.props

		row.meta.editing = false
		delete row.meta.courses
		this.props.loadTPCourses(row)
	}

	onCancel = () => {
		const { row } = this.props
		this.props.onCancelSubscription(row)
	}

	render() {
		const { row } = this.props;

		if (row.meta.editing) {
			const { courses, fields, trainingpath } = row.meta

			return (
				<SubscribeComponent
					courses={courses}
					fields={fields}
					saveSubscription={saveSubscription}
					afterSave={this.onAfterSave}
					trainingpath={trainingpath}
					entity_code={row.entity_code}
					onCancel={this.onCancel}
					label_interested={__('courseactions_has_interest')}
				/>
			)
		}
		if (!row.meta.mycourses) {
			this.props.loadTPCourses(row);
			return (<Loader />);
		}
		return (
			<Table
				id="userroles"
				columns={row.meta.columns}
				data={row.meta.mycourses}
				className='table regular_table no-margin-bottom alternate'
				search={false}
				itemsPerPage={99}
			/>
		);
	}
}

class UsersTrainingPaths extends React.Component {
	onEdit(row, e) {
		const { courseaction_ref, entity_code } = row

		e.stopPropagation()
		if (row.meta.courses) {
			row.meta.editing = true
			row.meta.expanded = true
			this.forceUpdate()
			return
		}
		http.post('/trainingpaths/edit.json', {trainingpath_code: courseaction_ref, entity_code: entity_code}, (response, success) => {
			// devolver todas as ações do percurso onde o user pode inscrever o formando, bem como cursos (sem ações) para manifestação de interesse
			if (!success) {
				return
			}
			response.courses.forEach(course => {
				if (course.actions.length > 1) {
					course.actions.unshift({courseaction_id: null, obs: none});
				}
			})
			const courses = model(response.courses, {status: false})
			row.meta.editing = true
			row.meta.expanded = true
			row.meta.courses = courses
			row.meta.fields = response.fields
			row.meta.trainingpath = response.trainingpath
			this.forceUpdate()
		})
	}

	onAfterSave = (row, response, success) => {
		debugger;
	}

	onCancelSubscription = (row) => {
		row.meta.editing = false
		this.forceUpdate()
	}

	formatActions = (column, row, config) => {
		const { prm } = this.props
		const actions = [];

		if (!row.meta.editing && (prm & 2) > 0 && row.confirmed == 1) {
			actions.push(
				<button key="edit"
					className="btn btn-tiny btn-primary"
					onClick={this.onEdit.bind(this, row)}
				>
					<em className="la la-pencil" />
					<span>Editar</span>
				</button>
			)
		}
		return actions
	}

	render() {
		const tp_row = this.props.row;

		if (!tp_row.meta.trainingpaths) {
			this.props.loadUsersTPs(tp_row);
			return (<Loader />);
		}
		return (
			<Table
				id="trainingpaths"
				columns={tp_row.meta.columns}
				data={tp_row.meta.trainingpaths}
				className='table regular_table no-margin-bottom alternate'
				search={false}
				itemsPerPage={9}
				renderRowExpanded={
					row => <UserTPCourses
						row={row}
						loadTPCourses={this.props.loadTPCourses}
						onCancelSubscription={this.onCancelSubscription}
					/>}
				getRowProps={getRowPropsExpanded}
				onRowSelected={row => {
					row.meta.expanded = row.meta.expanded === undefined ? true : !row.meta.expanded;
					return true;
				}}
				formatActions={this.formatActions}
			/>
		);
	}
}

export class TrainingPathsView extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			view: 0,
			urlMyTrainees: `/trainingpaths/myTrainees.json${props.company == 1 ? '?company=1' : ''}`,
			urlStatsOfTrainees: `/trainingpaths/statsOfTrainees.json?${props.company == 1 ? 'company=1&' : ''}`
		}
	}

	loadUsersTPs = row => {
		http.post('/trainingpaths/ofEntity.json',
			{
				data: { entity_code: row.entity_code },
				silent: true
			},
			(response, success) => {
				if (success) {
					row.meta.trainingpaths = response.data
					row.meta.columns = response.columns
					this.forceUpdate()
				}
			}
		)
	}

	loadTPCourses = (row) => {
		http.post('/trainingpaths/getCourses.json',
			{
				data: { trainingpath_code: row.courseaction_ref, entity_code: row.entity_code },
				silent: true
			},
			(response, success) => {
				if (success) {
					row.meta.mycourses = response.data
					row.meta.columns = response.columns
					this.forceUpdate()
				}
			}
		)
	}

	onChangeView = (e) => {
		this.setState({view: e.value})
	}

	onBeforePrint = () => {
		const { view } = this.state
		const params = {
			id: 'trainingpaths',
			tp_code: view
		}
		http.get('/pdf/generate.json', { data: params },
			(response, success) => {
				if (success && response.file) {
					window.open(response.file);
				}
			}
		)
		return false
	}

	render() {
		const { view, urlMyTrainees, urlStatsOfTrainees } = this.state
		let view_el = null

		if (view == 0) {
			view_el =
				<Table
					name="pf"
					label={__('courses_with_employees')}
					url={urlMyTrainees}
					className='table no-border-top alternate vcenter'
					renderRowExpanded={row => <UsersTrainingPaths
						prm={hp.settings.prm_training_pathway}
						row={row}
						loadUsersTPs={this.loadUsersTPs}
						loadTPCourses={this.loadTPCourses}
					/>}
					getRowProps={getRowPropsExpanded}
					onRowSelected={row => {
						row.meta.expanded = row.meta.expanded === undefined ? true : !row.meta.expanded;
						return true;
					}}
					onBeforePrint={this.onBeforePrint}
				/>
		}
		else {
			view_el =
				<Table
					url={`${urlStatsOfTrainees}tp_code=${view}`}
					classNameTableContainer="horizontal-table"
					className='table sticky no-border-top alternate vcenter'
					onBeforePrint={this.onBeforePrint}
				/>
		}

		return (
			<>
				<div className="widget-title bold no-border">
					<div className="pull-left">
						<Select model={this.state} name='view' options={hp.store.trainingPaths} onChange={this.onChangeView} title="Percurso formativo" />
					</div>
					<div className="clearfix" />
				</div>
				<div className="widget-body">
					{view_el}
				</div>
			</>
		)
	}
}
